<template>
  <div class="container">
    <h2 class="page-title">Overall survival</h2>
    <div class="img-item">
      <img src="../../assets/step5/map1.jpg" class="flow-img" alt="">
      <ul class="text">
        <li>
            Since the primary analysis, the median OS in Cohort 1
            increased over time<br/><br/>
            ★ <span class="star">After a median follow-up of 14.4 mo, median OS was 14.8 mo15 and after 29.3 mo (this analysis), median OS was 16.3 mo</span>
        </li>
      </ul>
    </div>
    <div class="img-item">
      <img src="../../assets/step5/map2.jpg" class="flow-img" alt="">
      <ul class="text">
        <li>
            In Cohort 2, median OS appeared stable and was comparable to the primary analysis 16
        </li>
      </ul>
    </div>
    <small class="foot-small">
        Plus (+) symbols indicate censored values.<br/>
        a As of data cutoff, 73 of 119 patients had experienced an OS event (death). b As of data cutoff, 242 of 310 patients had experienced an OS event (death).
    </small>
    <foot-component text=""></foot-component>
    <template>
      <router-link to="/step5-4" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link
      to="/step5-6" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
import footText from './footText'
export default {
  name: 'page6',
  components: {
    'foot-component': footText
  }
}
</script>

<style scoped>
.page-title {
  color:#1367a2;letter-spacing:.5pt;
  margin:0;margin-bottom:10px;
}
.img-item {display:block;font-size:0;margin-bottom:50px;}
.img-item > * {
  display:inline-block;vertical-align:top;
  width:47%;
}
.img-item .text {font-size:16px;}
.img-item .star {display:inline-block;width:80%;vertical-align:top;}
.foot-small {
  color:#666666;letter-spacing:.4pt;margin-bottom:150px;
  display:block;
}
a[class*="btn-"]{
  background:#1367a2;color:white;
}
a.btn-next {right:0;}

@media(max-width:750px){
  .img-item > *,
  .foot-small {width:90%;margin:20px auto;}
  a.btn-next {right:10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/step5/page6.vue